import React, { Fragment } from "react";
import classnames from "classnames";

export function Stepper({ step, totalSteps, children }) {
  return (
    <div className="stepper">
      <div className="header">
        {Array.from(Array(totalSteps).keys()).map((_, i) => {
          return (
            <div
              key={i}
              className={classnames({ "stepper-step": true, selected: i + 1 === step })}
            />
          );
        })}
      </div>
      <div className="panel">{children}</div>
    </div>
  );
}

export function StepSelector({ steps, selected }) {
  return steps.filter((step) => step.id === selected).map((step) => <Fragment key={step.id}>{step.content}</Fragment>);
}
